import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";
import { getEnv } from "@/env-runtime";

function normalizeBaseUrl(value) {
  return (value || "").trim().replace(/\/$/, "");
}

export default {
  namespaced: true,
  state() {
    return {
      // Core back-end REST API base URL (JWT-authenticated).
      // Defaulting to production for the Inventory-Forecasting rollout.
      apiUrl: normalizeBaseUrl(
        getEnv("VUE_APP_API_BASE") ||
        getEnv("VITE_API_BASE") ||
        getEnv("API_BASE") ||
        "https://r3backendstg.azurewebsites.net/api"
      ),

      appVersion:"2.86.1932",

      // Add map configuration
      mapbox: {
        // To be replaced with a r3mote.io Mapbox access token
        accessToken:
          "pk.eyJ1Ijoic2FtbXltYmIiLCJhIjoiY20zNHh6YXprMDNkbDJpcHk5Y2I0dmluayJ9.4c5UcG0DtdwycT_6C0TlWw",
        defaultCenter: [53.5461, -113.4937], // Edmonton area
        defaultZoom: 5,
        theme: {
          baseColor: "#1a1a1a", // Match app dark theme
          textColor: "#ffffff",
          borderColor: "#404040",
        },
      },

      environment: {
        containerName: "surface",
      },
    };
  },
  mutations,
  actions,
  getters,
};
